define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/_base",
	"csi/heading/Ref",
	"csi/heading/RefContainer",
	"csi/xml",
	"SiteAdmin/Locale"
], function(declare,lang,csiHeading,Ref,RefContainer,xml,Locale) {

	var	_Base = declare(Ref, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: assumption is that fmt is EnumList name and value is EnumValue name
			// NOTE: this is called directly from Values store to get name for filtered values, in addition
			// to being called when rendering the table
			// FIX: should the Values store use the base renderer to format values?
			var	enumValue = xml.enumCreate(fmt, value);
			return Locale.getConfigResolver().getEnumName(enumValue) || Locale.getBaseConfigResolver().getEnumName(enumValue);
 		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: set format on spec so it will be used to format filtered values
			spec.format = ctx.view.get("dependsOnEnum");
			return this.inherited(arguments);
		}
	});

	return declare(RefContainer, {
		constructor: function() {
			this.renBase = csiHeading.getClassRenderer(_Base, xml.ATTR_REF);
		},

		getNodeDisplayName: function(/*Context*/ctx, /*Node*/node) {
			// summary: get the node display name. Allows to override display names in derived classes.
			// FIX: why doesn't RefContainer use base renderer to get value?
			return this.renBase.formatValue(node.$Name, ctx.view.get("dependsOnEnum"));
		},

		getStoreOptions: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return special options to use when creating store
			return {
				customOperation: false,
				onResultItem: lang.hitch(ctx.view, ctx.view.onDependsOnEnumValue)
			};
		}
	});
});